<template>
  <div style="padding: 20px">
    <v-card fluid id="listener_commessa_dashboard">
      <!-- Snackbars to show alerts -->
      <v-snackbar
        content-class="snackbar"
        :color="snackbar_background"
        right
        v-model="snackbar"
        :timeout="3000"
      >
        <v-icon :color="snackbar_icon_color" :size="64">{{
          snackbar_icon
        }}</v-icon>
        <h2
          :style="{ color: snackbar_text_color + '!important' }"
          class="ml-16"
        >
          {{ snackbar_text }}
        </h2>
        <v-btn
          @click="snackbar = false"
          fab
          dark
          text
          small
          style="
            margin-top: -6rem;
            float: right !important;
            margin-right: -1rem !important;
          "
        >
          <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
        </v-btn>
      </v-snackbar>
      <!-- Commessa saving Confirmation dialog -->
      <v-dialog
        content-class="artDialog"
        persistent
        v-model="dialogSalvataggio"
        width="400"
      >
        <v-card>
          <v-toolbar dense class="indigo">
            <v-toolbar-title class="white--text">Salvataggio</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-6">
            <h3 style="text-align: left !important">
              Sei sicuro di voler salvare la commessa?
            </h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              dark
              @click="
                dialogSalvataggio = false;
                this.overlay = false;
              "
              >ANNULLA</v-btn
            >
            <v-btn color="success" dark @click="SalvaCommessa">CONFERMA</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Search new Article dialog -->
      <v-dialog persistent v-model="cod_articolo_dialog" width="unset">
        <v-overlay :value="overlay" style="z-index: 10">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Cod. Articolo Nuova Commessa
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  class="ml-3"
                  @click="goBack"
                  small
                >
                  <v-icon color="red">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Indietro</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="4">
                Inserisci il codice articolo per la nuova commessa:
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="cod_articolo"
                  label="Cod. Articolo"
                  placeholder="Cod. Articolo"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      class="mr-5"
                      @click="goToArticolo"
                      small
                    >
                      <v-icon color="success">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Vai all'Articolo</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" @click="searchResult" small>
                      <v-icon color="primary">mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Cerca</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Articolo Results -->
      <v-dialog
        v-model="dialogListaArticoli"
        content-class="artDialog"
        :scrollable="false"
        persistent
        width="unset"
      >
        <v-card>
          <v-toolbar dense class="indigo darken-1 headline" primary-title>
            <v-toolbar-title class="white--text">Articolo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="dialogListaArticoli = false"
                  small
                >
                  <v-icon color="error"> mdi-window-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-form>
            <v-container>
              <v-row class="mx-auto ml-auto">
                <v-col class="ml-auto" sm="8" md="3">
                  <v-text-field
                    class="shrink"
                    v-model="cod_articolo"
                    label="Cod Articolo"
                    required
                  ></v-text-field>
                </v-col>
                <v-col class="mr-auto" sm="3" md="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small>
                        <v-icon
                          v-on="on"
                          class
                          v-bind="attrs"
                          size="32"
                          color="#1a80b6"
                          >mdi-magnify</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Cerca Articolo</span>
                  </v-tooltip>
                </v-col>
                <v-col sm="2" xs="12" md="2">
                  <v-autocomplete
                    v-model="id_tipo"
                    :items="this.tipoList"
                    label="Tipo Articolo"
                    item-text="des"
                    required
                    return-object
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        color="light-blue lighten-4"
                        small
                        class="mb-0 mt-1"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="tiporemove(data.item)"
                        >{{ data.item.des }}</v-chip
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols sm="4" xs="12" md="3">
                  <v-autocomplete
                    v-model="id_famiglia"
                    :items="famiglia_list"
                    item-text="des"
                    required
                    return-object
                    label="Tipo Famiglia"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        color="light-blue lighten-4"
                        small
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        class="mb-0 mt-1"
                        @click:close="remove(data.item)"
                        >{{ data.item.des }}</v-chip
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="mr-auto" cols sm="4" xs="12" md="3"> </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-card-text style="max-height: 600px; overflow-y: auto">
            <v-row>
              <v-col md="12">
                <v-data-table
                  :footer-props="{
                    'items-per-page-options': [100, -1],
                  }"
                  :search="search"
                  :headers="this.headers"
                  :items="tableData"
                >
                  <template v-slot:[`item.actions`]="props">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          small
                          @click="onDetail(props.item)"
                        >
                          <v-icon style="float: left" color="primary"
                            >mdi-pencil</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Dettaglio Articolo</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Maschera per le commesse da generare -->
      <v-card>
        <v-toolbar primary-title dense color="indigo">
          <v-spacer></v-spacer>
          <Button
            colore_icona="primary"
            idForm="COMMESSA_DETTAGLIO"
            idOggetto="STAMPA_COMMESSA"
            mdi_icona="mdi-printer"
            testo_tooltip="Stampa Commessa"
            v-on:buttonClick="printCommessa"
            style="float: left !important"
          />

          <!-- Bottone degli allegati -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn class="ml-2" v-on="on" small @click="clickAllegati()">
                <v-icon color="primary">mdi-paperclip</v-icon>
              </v-btn>
            </template>
            <span>Allegati</span>
          </v-tooltip>

          <!-- Bottone di salva ed esci -->
          <Button
            classe_bottone="ml-2"
            colore_icona="success"
            idForm="COMMESSA_DETTAGLIO"
            idOggetto="SAlVA_COMMESSA"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva Commessa"
            v-on:buttonClick="clickSalva"
            style="float: left !important"
          />

          <!-- Bottone di salva e continua -->
          <Button
            classe_bottone="ml-2"
            colore_icona="success"
            idForm="COMMESSA_DETTAGLIO"
            idOggetto="SAlVA_COMMESSA"
            mdi_icona="mdi-content-save-move"
            testo_tooltip="Salva e Continua"
            v-on:buttonClick="clickSalvaEContinua"
            style="float: left !important"
          />

          <Button
            classe_bottone="ml-2"
            colore_icona="success"
            idForm="COMMESSA_DETTAGLIO"
            idOggetto="PART_PROGRAM_MACCHINA_COMMESSA"
            mdi_icona="mdi-cogs"
            testo_tooltip="Part Program"
          />
          <Button
            classe_bottone="mr-5 ml-2"
            colore_icona="primary"
            mdi_icona="mdi-order-bool-ascending-variant"
            testo_tooltip="QuickCheck"
            v-on:buttonClick="check_dialog_visible = true"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn style="float: left !important" @click="goBack" small>
                <v-icon v-on="on" v-bind="attrs" color="red"
                  >mdi-keyboard-backspace</v-icon
                >
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <form class="px-5" v-if="id_commessa_tmp == -1">
          <v-container fluid>
            <v-row align="center" justify="start">
              <v-col cols="3" justify="center" class="py-0">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="CREA_CODICE_COMMESSA"
                  label_input="Codice Commessa"
                  palceholder_input="Codice Commessa"
                  :readonly="true"
                  :vmodel="cod_commessa"
                  v-on:changeText="(val) => (this.cod_commessa = val)"
                />
              </v-col>
              <v-col cols="3" justify="center" class="py-0">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatdatacommessa"
                      label="Data Commessa"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    style="width: 100% !important"
                    v-model="data_commessa"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" justify="center" class="py-0">
                <v-text-field
                  v-model="data_spedizione"
                  label="Data Scadenza / Lavorazione"
                  type="datetime-local"
                />
                <!--<v-menu
                  v-model="menu5"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="format_data_spedizione"
                      label="Data Scadenza / Lavorazione"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    style="width: 100% !important"
                    v-model="data_spedizione"
                    @input="menu5 = false"
                  ></v-date-picker>
                </v-menu>-->
              </v-col>
              <v-col cols="3" justify="center" class="py-0">
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatdataconsegna"
                      label="Data Consegna"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    style="width: 100% !important"
                    v-model="data_consegna"
                    @input="menu3 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" md="3" justify="center" class="py-0">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="CM_DES_COMMESSA"
                  label_input="Descrizione Commessa"
                  palceholder_input="Descrizione Commessa"
                  :vmodel="des_commessa"
                  v-on:changeText="(val) => (this.des_commessa = val)"
                />
              </v-col>
              <v-col cols="2" justify="center" class="py-0">
                <v-autocomplete
                  v-model="des_stato"
                  :items="stato_list"
                  item-text="des"
                  label="Stato"
                  placeholder="Stato"
                  required
                  item-value="des"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="3" justify="center" class="py-0">
                <v-text-field
                  style="width: 500px !important"
                  v-model="cod_articolo"
                  placeholder="Codice Articolo"
                  label="Codice Articolo"
                  v-on:keydown.enter.prevent="searchResult"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="searchResult"
                      style="color: #03a9f4"
                      class="ml-2"
                      >mdi-magnify</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="py-0" cols="2">
                Col. Testo Sched.
                <v-btn
                  @click="modificaColore(1)"
                  :color="colore_testo == null ? '#000000' : colore_testo"
                  small
                >
                  <v-icon color="white">
                    {{ colore_testo == null ? "mdi-help" : "" }}
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col class="py-0" cols="2">
                Col. Sfondo Sched.
                <v-btn
                  @click="modificaColore(2)"
                  :color="colore_sfondo == null ? '#000000' : colore_sfondo"
                  small
                >
                  <v-icon color="white">
                    {{ colore_sfondo == null ? "mdi-help" : "" }}
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="3" md="3" justify="center" class="py-0">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="CM_DES_ARTICOLO"
                  label_input="Des. Articolo"
                  palceholder_input="Des. Articolo"
                  :vmodel="des_articolo"
                  v-on:changeText="(val) => (this.des_articolo = val)"
                />
              </v-col>
              <v-col cols="3" md="3" justify="center" class="py-0">
                <v-autocomplete
                  v-model="id_tipo"
                  :items="tipoList"
                  placeholder="Tipo Articolo"
                  label="Tipo Articolo"
                  item-text="des"
                  required
                  item-value="id_tabella"
                ></v-autocomplete>
              </v-col>
              <v-col cols="3" md="3" justify="center" class="py-0">
                <v-autocomplete
                  v-model="id_famiglia"
                  :items="famiglia_list"
                  placeholder="Famiglia"
                  label="Famiglia"
                  item-text="des"
                  required
                  item-value="id_tabella"
                ></v-autocomplete>
              </v-col>
              <v-col cols="2" md="3" justify="center" class="py-0">
                <v-autocomplete
                  style="width: 350px !important"
                  v-model="id_tipo_fornitura"
                  :items="fornitura_list"
                  placeholder="Fornitura"
                  label="Fornitura"
                  item-text="des"
                  required
                  item-value="id_tabella"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="2"
                justify="center"
                class="py-0"
                id="listener_quantita"
              >
                <InputSeparatore
                  :destinazione="'listener_quantita'"
                  :label="'Quantità'"
                  :id="'inputQuantita'"
                  :append_text="`${
                    items_unita_misura.filter(
                      (elem) => elem.id_tabella == id_um
                    ).length > 0
                      ? items_unita_misura.filter(
                          (elem) => elem.id_tabella == id_um
                        )[0].des
                      : '(N/D)'
                  }`"
                />
              </v-col>
              <v-col cols="2" justify="center" class="py-0">
                <v-text-field
                  label="Lotto"
                  readonly
                  v-model="cod_lotto"
                  :min="0"
                />
              </v-col>
              <v-col cols="2" justify="center" class="py-0">
                <v-text-field label="Indice" v-model="indice_disegno" />
              </v-col>
              <v-col cols="3" justify="center" class="py-0">
                <v-menu
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatdatadum"
                      label="D.U.M"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    style="width: 100% !important"
                    v-model="dum"
                    @input="menu4 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" justify="center" class="py-0">
                <v-text-field label="Riferimento" v-model="riferimento" />
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="2">
                <v-select
                  label="Tipo Avanzamento"
                  :items="tipi_avanzamento"
                  item-text="des"
                  item-value="val_int"
                  v-model="tipo_avanzamento"
                  @change="chkMagazzinoPredefinito"
                >
                </v-select>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  label="Tipo Commessa"
                  :items="tipi_commessa"
                  item-text="des"
                  item-value="cod"
                  v-model="tipo_commessa"
                >
                  <template #label>
                    <span class="">Tipo Commessa</span>
                    <a @click.stop style="pointer-events: all">
                      <v-icon @click="apriModules" color="primary">
                        mdi-eye
                      </v-icon>
                    </a>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  label="Magazzino"
                  :items="items_magazzini"
                  :item-text="
                    (item) => `${item.cod_magazzino} - ${item.des_magazzino}`
                  "
                  item-value="id_magazzino"
                  v-model="id_magazzino"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <div>
                  <div style="display: inline-block; font-size: 17px">
                    Cod. Packaging:
                    <b>{{
                      cod_packaging_sel == null || cod_packaging_sel == ""
                        ? "N/D"
                        : cod_packaging_sel
                    }}</b>
                  </div>
                  <div class="ml-2" style="display: inline-block">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickPackaging"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-package-variant </v-icon>
                        </v-btn>
                      </template>
                      <span>Seleziona Packaging</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
              <!--<v-col cols="6">
                <v-checkbox
                  label="Picking List"
                  v-model="flag_picking"
                  :disabled="flag_readonly"
                >
                </v-checkbox>
              </v-col>-->
            </v-row>
          </v-container>
        </form>
        <!-- Maschera per le commesse già generate -->
        <form class="px-5" v-if="id_commessa_tmp > 0">
          <v-container fluid>
            <v-row align="center" justify="start" style="font-size: 17px">
              <v-col class="py-0" md="2" cols="2" justify="center">
                <!--<b>Cod. Commessa:</b> {{ cod_commessa }}-->
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_CODICE_COMMESSA"
                  label_input="Codice Commessa"
                  palceholder_input="Codice Commessa"
                  :readonly="true"
                  stile="outline: none;"
                  :vmodel="cod_commessa"
                  v-on:changeText="(val) => (this.cod_commessa = val)"
                />
              </v-col>
              <v-col class="py-0" md="3" cols="2" justify="center">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_DES_COMMESSA"
                  label_input="Des. Commessa"
                  palceholder_input="Des. Commessa"
                  :vmodel="des_commessa"
                  v-on:changeText="(val) => (this.des_commessa = val)"
                />
              </v-col>
              <v-col class="py-0" cols="4" md="2" justify="center">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatdatacommessa"
                      label="Data Commessa"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    style="width: 100% !important"
                    v-model="data_commessa"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" justify="center" class="py-0">
                <v-text-field
                  v-model="data_spedizione"
                  label="Data Scadenza / Lavorazione"
                  type="datetime-local"
                />
                <!--<v-menu
                                    v-model="menu5"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="format_data_spedizione"
                                            label="Data Scadenza / Lavorazione"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        style="width: 100% !important"
                                        v-model="data_spedizione"
                                        @input="menu5 = false"
                                    ></v-date-picker>
                                </v-menu>-->
              </v-col>
              <v-col class="py-0" cols="4" md="2" justify="center">
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatdataconsegna"
                      label="Data Consegna"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    style="width: 100% !important"
                    v-model="data_consegna"
                    @input="menu3 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-0" cols="2" justify="center">
                <v-autocomplete
                  label="Stato"
                  placeholder="Stato"
                  item-text="des"
                  v-model="des_stato"
                  :items="stato_list"
                  item-value="des"
                ></v-autocomplete>
              </v-col>
              <v-col class="py-0" cols="2" justify="center">
                <TextField
                  idForm="COMMESSA"
                  :readonly="true"
                  idOggetto="MODIFICA_COD_ARTICOLO"
                  label_input="Cod. Articolo"
                  palceholder_input="Cod. Articolo"
                  :vmodel="cod_articolo"
                  v-on:changeText="(val) => (this.cod_articolo = val)"
                />
              </v-col>
              <v-col class="py-0" cols="3">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_DES_ARTICOLO"
                  label_input="Descrizione"
                  palceholder_input="Descrizione"
                  :vmodel="des_articolo"
                  v-on:changeText="(val) => (this.des_articolo = val)"
                />
              </v-col>
              <v-col class="py-0" cols="2">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_TIPO_ARTICOLO"
                  label_input="Tipo"
                  palceholder_input="Tipo"
                  :vmodel="tipo_articolo"
                  :readonly="true"
                />
              </v-col>
              <v-col class="py-0" cols="3" justify="center">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_FAMIGLIA_ARTICOLO"
                  label_input="Famiglia"
                  palceholder_input="Famiglia"
                  :vmodel="famiglia_articolo"
                  :readonly="true"
                />
              </v-col>
              <v-col class="py-0" cols="3" justify="center">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_FORNITURA_ARTICOLO"
                  label_input="Fornitura"
                  palceholder_input="Fornitura"
                  :vmodel="fornitura_articolo"
                  :readonly="true"
                />
              </v-col>
              <v-col
                class="py-0"
                cols="2"
                justify="center"
                id="listener_quantita"
              >
                <InputSeparatore
                  :destinazione="'listener_quantita'"
                  :label="'Quantità'"
                  :id="'inputQuantita'"
                  :append_text="`${
                    items_unita_misura.filter(
                      (elem) => elem.id_tabella == id_um
                    ).length > 0
                      ? items_unita_misura.filter(
                          (elem) => elem.id_tabella == id_um
                        )[0].des
                      : '(N/D)'
                  }`"
                />
              </v-col>
              <v-col class="py-0" cols="2" justify="center">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_DUM_COMMESSA"
                  label_input="D.U.M"
                  palceholder_input="D.U.M"
                  :vmodel="dum"
                  :readonly="true"
                />
              </v-col>
              <v-col class="py-0" cols="2" justify="center">
                <TextField
                  idForm="COMMESSA"
                  idOggetto="MODIFICA_INDICE_DISEGNO"
                  label_input="Indice"
                  palceholder_input="Indice"
                  :vmodel="indice_disegno"
                  :readonly="true"
                />
              </v-col>
              <v-col class="py-0" cols="2" justify="center">
                <v-btn
                  class="mt-3"
                  @click="clickVisualizzaDisegno()"
                  style="z-index: 1"
                >
                  <v-icon color="primary"> mdi-eye </v-icon>
                </v-btn>
              </v-col>
              <v-col class="py-0" cols="2" justify="center">
                <v-text-field
                  label="Lotto"
                  v-model="cod_lotto"
                  :readonly="true"
                />
              </v-col>
              <v-col class="py-0" cols="5" justify="center">
                <v-text-field label="Riferimento" v-model="riferimento" />
              </v-col>
              <v-col class="py-0" cols="2">
                Col. Testo Sched.
                <v-btn
                  @click="modificaColore(1)"
                  :color="colore_testo == null ? '#000000' : colore_testo"
                  small
                >
                  <v-icon color="white">
                    {{ colore_testo == null ? "mdi-help" : "" }}
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col class="py-0" cols="2">
                Col. Sfondo Sched.
                <v-btn
                  @click="modificaColore(2)"
                  :color="colore_sfondo == null ? '#000000' : colore_sfondo"
                  small
                >
                  <v-icon color="white">
                    {{ colore_sfondo == null ? "mdi-help" : "" }}
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="2">
                <v-select
                  label="Tipo Avanzamento"
                  :items="tipi_avanzamento"
                  item-text="des"
                  item-value="val_int"
                  v-model="tipo_avanzamento"
                  @change="chkMagazzinoPredefinito"
                >
                </v-select>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  label="Tipo Commessa"
                  :items="tipi_commessa"
                  item-text="des"
                  item-value="cod"
                  v-model="tipo_commessa"
                >
                  <template #label>
                    <span class="">Tipo Commessa</span>
                    <a @click.stop style="pointer-events: all">
                      <v-icon @click="apriModules" color="primary">
                        mdi-eye
                      </v-icon>
                    </a>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  label="Magazzino"
                  :items="items_magazzini"
                  :item-text="
                    (item) => `${item.cod_magazzino} - ${item.des_magazzino}`
                  "
                  item-value="id_magazzino"
                  v-model="id_magazzino"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <div>
                  <div style="display: inline-block; font-size: 17px">
                    Cod. Packaging:
                    <b>{{
                      cod_packaging_sel == null || cod_packaging_sel == ""
                        ? "N/D"
                        : cod_packaging_sel
                    }}</b>
                  </div>
                  <div class="ml-2" style="display: inline-block">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickPackaging"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-package-variant </v-icon>
                        </v-btn>
                      </template>
                      <span>Seleziona Packaging</span>
                    </v-tooltip>
                  </div>

                  <!-- Bottone degli impegni del contenitore -->
                  <div class="ml-2" style="display: inline-block">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickImpegniContenitore"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-warehouse </v-icon>
                        </v-btn>
                      </template>
                      <span>Impegni Packaging</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
              <!--<v-col cols="6">
              <v-col cols="2">
                <v-checkbox
                  label="Picking List"
                  v-model="flag_picking"
                  :disabled="flag_readonly"
                >
                </v-checkbox>
              </v-col>
              <v-col class="mt-4" cols="3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="prelieviCommessa"
                      :disabled="id_commessa == null"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"
                        >mdi-arrange-send-backward
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Impegni</span>
                </v-tooltip>
              </v-col> -->
            </v-row>
          </v-container>
        </form>
      </v-card>
      <!-- Children injection -->
      <CommesaDrawer
        @DelCiclo="updateCicliList($event)"
        @delMacchina="delMacchina($event)"
        @delPersonale="delPersonale($event)"
        @delFornitura="delFornitura($event)"
        @delDistinta="delDistinta($event)"
        @deleteAllFasi="deleteAllFasi($event)"
        :is_quantita_updated="is_quantita_updated"
        @updateDrawer="updateArticle($event)"
        @selezionata_distinta="handleSelezionataDistinta"
        @setqueryevent="handleSetQueryEvent"
        @reload_commessa="handleReloadCommessa"
        :idArticolo="id_articolo"
        :key="key_commessa_drawer"
        :CicloData="CommessaData"
        :items_tipi_pianificazione="items_tipi_pianificazione"
        ref="commessa_drawer"
      />
      <!-- To see Attached disegno -->
      <v-dialog persistent v-model="visualizza_disegno_visible">
        <VisualizzaDisegno
          @click_chiudi="
            visualizza_disegno_visible = !visualizza_disegno_visible
          "
          :visible="visualizza_disegno_visible"
          :work_order_sel="work_order_sel"
        />
      </v-dialog>
      <!-- Gestione dialog Stampa Cartellino -->
      <v-dialog v-model="pdfdialog" width="unset" content-class="pdfdialog">
        <v-card>
          <v-toolbar
            class="white--text"
            color="blue"
            dense
            style="position: sticky; top: 0px; z-index: 1"
          >
            <v-toolbar-title> Stampa Pdf </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="red--text"
              @click="pdfdialog = false"
              color="blue-grey lighten-5"
              small
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <iframe
                :src="selected_pdf"
                frameborder="0"
                style="height: 90vh !important; width: 90vw !important"
              >
              </iframe>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Dialog della selezione packaging -->
      <v-dialog v-model="packaging_visible">
        <Packaging2
          class="px-0 pb-0"
          @click_indietro="packaging_visible = false"
          :data="{ id_articolo: id_articolo }"
          :custom_headers="headers_packaging"
          :pack_id_commessa_sel="id_packaging_sel"
          :quicklabel_allowed="quicklabel_allowed"
          :show_exit_button="true"
          :show_save_button="true"
          :visible="packaging_visible"
          @selezione_packaging="handleSelezionePackaging"
        />
      </v-dialog>

      <!--Loader  -->
      <v-overlay :value="overlay" style="z-index: 1">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>

    <!-- Mini dialog per indicare i work order attivi -->
    <v-dialog v-model="dialog_impegni" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="center" cols="4"></v-col>
            <v-col align="center" cols="4">
              <v-btn
                @click="
                  SalvaCommessa();
                  dialog_impegni = false;
                "
                small
              >
                <span style="color: rgb(76, 175, 80)"
                  >Conferma Irreversibile</span
                >
              </v-btn>
            </v-col>
            <v-col align="right" cols="4">
              <v-btn @click="dialog_impegni = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text class="pt-3">
          <div style="display: inline-block; max-width: 500px">
            <span style="font-size: 15px">
              Risultano esserci dei Work Order attivi per questa commessa.
              Confermando di voler modificare lo stato della commessa, i Work
              Order associati verranno forzati a fermarsi. Si intende procedere?
            </span>
          </div>
          <v-data-table
            :headers="headers_commesse_aperte"
            hide-default-footer
            :items="items_commesse_aperte"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di scelta dei colori -->
    <v-dialog v-model="dialog_colori_visible" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Colore {{ colore_sel === 1 ? "Testo" : "Sfondo" }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaColore"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiModificaColore"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center" v-if="colore_sel === 1">
              <v-col cols="12">
                <v-color-picker
                  class="ma-2"
                  :swatches="swatches"
                  show-swatches
                  v-model="colore_testo_tmp"
                ></v-color-picker>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" v-else>
              <v-col cols="12">
                <v-color-picker
                  class="ma-2"
                  :swatches="swatches"
                  show-swatches
                  v-model="colore_sfondo_tmp"
                ></v-color-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog degli impegni del packaging -->
    <v-dialog v-model="dialog_impegni_contenitore" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impegni Contenitore
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiImpegniContenitore"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container class="py-0" fluid>
            <v-row
              align="center"
              dense
              justify="center"
              v-if="colore_sel === 1"
            >
              <v-col class="py-0" cols="12">
                <v-data-table
                  class="my-0 py-0"
                  :headers="headers_impegni_contenitore"
                  :items="items_impegni_contenitore"
                ></v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog del componente dinamico Check -->
    <v-dialog class="ma-0 pa-0" v-model="check_dialog_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeCheck"
            :component="component_check"
            ref="windowframe_generico"
            @loaded="handleCheckLoaded()"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Window Frame dei Modules -->
    <v-dialog v-model="dialog_modules" max-width="800" min-width="800">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%; overflow-y: hidden">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'fwk'"
            ref="windowframe_modules"
            @chiudi="chiudiModules"
            :input_args="input_args_modules"
            :key="key_modules"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog degli allegati -->
    <v-dialog class="ma-0 pa-0" v-model="allegati_visible" width="1200px">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        width="calc(100vw - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            referrerpolicy="origin"
            @click_chiudi="allegati_visible = false"
            :component="'allegati'"
            ref="windowframe_allegati"
            :input_args="input_args_allegati"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Dialog della gestione prelievi -->
    <!-- <v-dialog persistent v-model="prelievi_visible">
      <Prelievi
        @click_chiudi="prelievi_visible = !prelievi_visible"
        :fase_sel="work_order_sel"
        :visibile="prelievi_visible"
      />
    </v-dialog> -->
  </div>
</template>
<script>
// Inputseparatore generic input to show value in thousands
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import CommesaDrawer from "./CommesaDrawer";
import InputSeparatore from "@/components/TOOLS/InputSeparatore.vue";
import moment from "moment";
import Packaging2 from "@/views/PRODUCTION/Articolo/ArticoloDrawer/Packaging2.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TextField from "@/components/TOOLS/FormComponentPermissions/TextField.vue";
import VisualizzaDisegno from "@/components/PRODUCTION/ProduzioneOnline/VisualizzaDisegno.vue";
// import Prelievi from "@/components/PRODUCTION/Produzione/Prelievi.vue";
export default {
  name: "commessa",
  components: {
    Button,
    CommesaDrawer,
    InputSeparatore,
    Packaging2,
    SnackbarQV,
    TextField,
    VisualizzaDisegno,
    WindowFrame,
    // Prelievi,
  },
  props: {
    id_commessa: { deafault: null, type: Number },
    componente_interno: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili di supporto
      chk_contenitori_magazzino_on_save: 0,
      cod_articolo: "",
      cod_packaging_sel: "",
      colore_sel: 1,
      colore_sfondo: null,
      colore_sfondo_tmp: new Object(),
      colore_testo: null,
      colore_testo_tmp: new Object(),
      component_check: "check",
      data: {
        commessa: [],
      },
      data_spedizione: "",
      des: "",
      des_stato_aperto: null,
      flag_picking: false,
      flag_readonly: false,
      id_commessa_tmp: null,
      id_magazzino: null,
      input_args_modules: {
        tipo: "COMMESSA_TIPO",
        showScadenza: false,
        nome: "Tipo Commessa",
        filter: "",
        landing_page: "/modules",
        nome_col: "Descrizione",
      },
      id_packaging_sel: null,
      is_quantita_updated: false,
      key_commessa_drawer: 0,
      key_modules: 0,
      landing_page_check: "dashboard",
      quantita_salvata: 0,
      quicklabel_allowed: 0,
      riferimento: "",
      salva_e_continua: false,
      search: "",
      tipo_avanzamento: null,
      tipo_commessa: null,
      work_order_sel: { id_articolo: null },
      input_args_allegati: {
        id_utente: localStorage.id,
        id_riferimento: -1,
        cod_riferimento: "commessa",
        pk_riferimento: "id_commessa",
      },

      // Modals
      allegati_visible: false,
      check_dialog_visible: false,
      cod_articolo_dialog: false,
      dialog_colori_visible: false,
      dialog_impegni_contenitore: false,
      dialog_impegni: false,
      dialog_modules: false,
      dialogSalvataggio: false,
      menu5: false,
      packaging_visible: false,
      prelievi_visible: false,
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      visualizza_disegno_visible: false,

      // Array
      CommessaData: [],
      deleteAllFasiLista: [],
      deletedCicli: [],
      deletedDistinta: [],
      deletedFornitura: [],
      deletedMacchina: [],
      deletedPersonale: [],
      headers: [],
      headers_commesse_aperte: [
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Utente",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "data_inizio",
        },
      ],
      headers_impegni_contenitore: [
        {
          text: "Cod. Contenitore",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Des. Contenitore",
          sortable: false,
          value: "des_articolo",
        },
        {
          text: "Impegno Commessa",
          sortable: false,
          value: "quantita_impegno",
        },
        {
          text: "Giacenza Disponibile",
          sortable: false,
          value: "giacenza",
        },
        {
          text: "Cod. Magazzino",
          sortable: false,
          value: "cod_magazzino",
        },
        {
          text: "Des. Magazzino",
          sortable: false,
          value: "des_magazzino",
        },
      ],
      items_impegni_contenitore: [],
      items_magazzini: new Array(),
      items_tipi_pianificazione: new Array(),
      tipi_avanzamento: [],
      tipi_commessa: [],
      tableData: [],
      cicloData: [],
      swatches: [
        ["#FF0000", "#AA0000", "#550000"],
        ["#FFFF00", "#AAAA00", "#555500"],
        ["#00FF00", "#00AA00", "#005500"],
        ["#00FFFF", "#00AAAA", "#005555"],
        ["#0000FF", "#0000AA", "#000055"],
      ],
      id_articolo: null,
      singleCommessa: "",
      immagine_preview: "",
      data_commessa: "",
      data_consegna: "",
      dialogAllegati: false,
      dialogListaArticoli: false,
      dialogAggiungiAllegati: false,
      des_stato: "",
      cod_commessa: "",
      des_commessa: "",
      id_um: null,
      id_stato: "",
      quantita: 0,
      cod_lotto: "",
      indice_disegno: "",
      dum: "",
      des_articolo: "",
      barcode: "",
      tipo_articolo: "",
      id_tipo_fornitura: "",
      famiglia_articolo: "",
      fornitura_articolo: "",
      menu2: false,
      menu3: false,
      menu4: false,
      famiglia_list: [],
      tipoList: [],
      itemList: [],
      items_unita_misura: [],
      tipo_fornitura: "",
      fornitura_list: [],
      des_stato_list: [],
      headers_packaging: [
        {
          text: "Seleziona",
          value: "selected_for_commessa",
          sortable: false,
        },
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Cod. Packaging",
          value: "cod_articolo_packaging",
          sortable: false,
        },
        {
          text: "Ragione Sociale",
          value: "ragione_sociale",
          sortable: false,
        },
        {
          text: "Tipo Contenitore",
          value: "des_contenitore",
          sortable: false,
        },
        {
          text: "Q.tà Contenitore",
          value: "qta_contenitore",
          sortable: false,
        },
        {
          text: "Tipo Imballo",
          value: "des_imballo",
          sortable: false,
        },
        {
          text: "Q.tà Imballo",
          value: "qta_imballo",
          sortable: false,
        },
        {
          text: "Q.tà Minima Spedizione",
          value: "qta_minima_spedizione",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      items_commesse_aperte: new Array(),
      stato_list: [],
      id_tipo: 0,
      id_famiglia: 0,
      overlay: false,
      pdfdialog: false,
      selected_pdf: null,
    };
  },
  watch: {
    quantita: {
      immediate: true,
      handler() {
        this.is_quantita_updated =
          this.quantita == this.quantita_salvata ? false : true;
      },
    },
  },
  methods: {
    aggiornaTipoCommessa() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "COMMESSA_TIPO",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              this.tipi_commessa = res.data;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
    apriModules() {
      this.dialog_modules = true;
      this.key_modules = this.key_modules === 0 ? 1 : 0;
    },
    chkMagazzinoContenitore() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "checkmagazzinocontenitore",
          token: localStorage.user_token,
          id_articolo_packaging:
            this.CommessaData.commessa[0].id_articolo_packaging,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.result == 1) {
              return true;
            } else {
              return false;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    chkMagazzinoPredefinito() {
      // Se l'utente ha selezionato un tipo di commessa...
      if (
        this.tipo_avanzamento == 2 ||
        this.tipo_avanzamento == 3 ||
        this.tipo_avanzamento == 4
      ) {
        /* ... E se l'articolo selezionato non ha un
         * magazzino predefinito, avviso l'utente. */
        if (this.CommessaData.commessa[0].id_magazzino == null) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Attenzione: questo articolo non ha un magazzino predefinito: non saranno mai registrati movimenti a magazzino."
          );
        }
      }
    },
    chiudiImpegniContenitore() {
      this.dialog_impegni_contenitore = false;
    },
    chiudiModules() {
      this.dialog_modules = false;

      // Aggiorno le operazioni all'interno della finestra di dialogo.
      this.aggiornaTipoCommessa();
    },
    chiudiModificaColore() {
      this.dialog_colori_visible = false;
    },
    clickAllegati() {
      // Controllo che la commessa non sia nuova.
      if (this.CommessaData.commessa[0].id_commessa == -1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Salvare la commessa prima di gestire gli allegati."
        );
        return;
      }

      this.input_args_allegati.id_riferimento =
        this.CommessaData.commessa[0].id_commessa;
      this.allegati_visible = true;
    },
    clickImpegniContenitore() {
      // Controllo che siano impostati i dati minimi.
      if (
        !(
          this.CommessaData.commessa &&
          this.CommessaData.commessa[0] &&
          this.CommessaData.commessa[0].id_articolo_packaging
        )
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non c'è un packaging associato a questa commessa."
        );
        return;
      }

      if (
        this.stato_list.filter(
          (e) =>
            e.id_tabella == this.CommessaData.commessa[0].id_stato &&
            e.val_int == 1
        ).length == 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'impegno del packaging è consultabile solo per commesse aperte."
        );

        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getimpegnicontenitore",
          token: localStorage.user_token,
          id_commessa: this.CommessaData.commessa[0].id_commessa,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_impegni_contenitore = res.data.result;
            this.dialog_impegni_contenitore = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    clickPackaging() {
      this.packaging_visible = true;
    },
    getCommessaFull() {
      this.overlay = true;
      let getcommessa = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: this.$route.params.id,
          componenti_stessa_commessa: 1,
          id_profilo: localStorage.id_profilo,
        },
      };
      this.$store.dispatch("api", getcommessa).then((res) => {
        this.overlay = false;
        this.CommessaData = res.data;
        this.key_commessa_drawer = this.key_commessa_drawer == 0 ? 1 : 0;
        this.singleCommessa = this.CommessaData.commessa[0];
        this.cicloData = this.CommessaData.ciclo;
        this.flag_picking = this.singleCommessa.flag_picking;
        this.tipo_avanzamento = this.singleCommessa.tipo_avanzamento;
        this.tipo_commessa = this.singleCommessa.tipo_commessa;
        this.id_magazzino = this.singleCommessa.id_magazzino;
        this.indice_disegno = this.singleCommessa.indice_disegno;
        this.id_stato = this.singleCommessa.id_stato;
        this.cod_lotto = this.singleCommessa.cod_lotto;
        this.id_articolo = this.singleCommessa.id_articolo;
        this.stato_list.map((de) => {
          if (de.id_tabella === this.CommessaData.commessa[0].id_stato) {
            this.des_stato = de.des;
          }
        });
        if (this.flag_picking && this.des_stato != "Creata") {
          this.flag_readonly = true;
        }
        this.cod_commessa = this.CommessaData.commessa[0].cod_commessa;
        this.id_um = this.CommessaData.commessa[0].id_um;
        this.des_commessa = this.CommessaData.commessa[0].des_commessa;
        this.colore_sfondo = this.CommessaData.commessa[0].colore_sfondo;
        this.colore_testo = this.CommessaData.commessa[0].colore_testo;
        this.quantita = this.CommessaData.commessa[0].quantita;
        this.quantita_salvata = this.CommessaData.commessa[0].quantita;
        this.id_packaging_sel =
          this.CommessaData.commessa[0].id_articolo_packaging;
        this.cod_packaging_sel =
          this.CommessaData.commessa[0].cod_articolo_packaging;
        this.riferimento = this.CommessaData.commessa[0].riferimento;
        this.data_commessa = this.CommessaData.commessa[0].data_commessa;
        this.data_consegna = this.CommessaData.commessa[0].data_consegna;
        this.data_spedizione = this.CommessaData.commessa[0].data_spedizione;
        this.des_articolo = this.CommessaData.commessa[0].des_articolo;
        this.cod_articolo = this.CommessaData.commessa[0].cod_articolo;
        this.barcode = this.CommessaData.commessa[0].barcode;
        this.tipo_articolo = this.CommessaData.commessa[0].tipo_articolo;
        this.famiglia_articolo =
          this.CommessaData.commessa[0].famiglia_articolo;
        this.id_famiglia = this.CommessaData.commessa[0].id_famiglia;
        this.id_commessa_tmp = this.CommessaData.commessa[0].id_commessa;
        this.fornitura_articolo =
          this.CommessaData.commessa[0].fornitura_articolo;
        this.dum = this.CommessaData.commessa[0].dum
          ? moment(this.CommessaData.commessa[0].dum).format("DD/MM/YYYY")
          : "";
        this.cod_lotto = this.CommessaData.commessa[0].cod_lotto;
        this.indice_disegno = this.CommessaData.commessa[0].indice_disegno;
        // Valorizzo la variabile amount con un custom event
        // Compongo un messaggio.
        let messaggio = {
          detail: {
            numero: this.quantita,
          },
          src: null,
        };
        setTimeout(() => {
          // Inserisco il messaggio in un evento custom.
          let evento = new CustomEvent("numero_iniziale", messaggio);
          // Consegno alla mia destinazione l'evento
          document
            .getElementById("listener_InputSeparatoreinputQuantita")
            ?.dispatchEvent(evento);
        }, 10);
      });
    },
    getModuliDrawer() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni su QuickLabel, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              ).length > 0
            ) {
              this.quicklabel_allowed = res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              )[0].val_int;
            }

            /* Se l'array contiene informazioni sul check
             * dei magazzini dei contenitori, le registro. */
            if (
              res.data.result.filter(
                (e) =>
                  e.codice === "COMMESSA" &&
                  e.descrizione == "chk_contenitori_magazzino_on_save"
              ).length > 0
            ) {
              this.chk_contenitori_magazzino_on_save = res.data.result.filter(
                (e) =>
                  e.codice === "COMMESSA" &&
                  e.descrizione == "chk_contenitori_magazzino_on_save"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    handleCheckLoaded() {
      this.$refs.windowframe_generico.postEvent("setparams", {
        landing_page: this.landing_page_check,
      });
    },
    handleReloadCommessa() {
      this.getCommessaFull();
    },
    handleSetQueryEvent() {
      this.$refs.SnackbarQV.print(
        "success",
        "I dati della commessa sono stati aggiornati."
      );

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquantitacommessa",
          token: localStorage.user_token,
          id_commessa: this.id_commessa_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.quantita = res.data.quantita[0].quantita;
            this.quantita_salvata = res.data.quantita[0].quantita;
            this.CommessaData.commessa[0].quantita =
              res.data.quantita[0].quantita;

            // Forzo l'aggiornamento dell'input della quantità
            let messaggio = {
              detail: {
                numero: this.quantita,
              },
              src: null,
            };
            let evento = new CustomEvent("numero_iniziale", messaggio);
            document
              .getElementById("listener_InputSeparatoreinputQuantita")
              ?.dispatchEvent(evento);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    modificaColore(arg) {
      this.colore_sel = arg;
      this.colore_sfondo_tmp.hex = this.colore_sfondo;
      this.colore_testo_tmp.hex = this.colore_testo;
      this.dialog_colori_visible = true;
    },
    salvaModificaColore() {
      /* Aggiorno il colore del testo o sfondo in base
       * alla selezione con cui ho aperto il dialog. */
      if (this.colore_sel === 1) {
        this.colore_testo = this.colore_testo_tmp.hex;
      } else {
        this.colore_sfondo = this.colore_sfondo_tmp.hex;
      }

      // Chiudo la finestra di dialogo.
      this.dialog_colori_visible = false;
    },

    closeCheck() {
      this.check_dialog_visible = false;
    },

    clickSalva() {
      if (this.des_stato == null || this.des_stato == "") {
        this.$refs.SnackbarQV.print("orange", "Valorizzare lo stato.");
        return;
      }

      // Se la commessa è nuova, procedo normalmente.
      if (this.id_commessa_tmp === -1) {
        this.dialogSalvataggio = true;
      } else {
        /* Se non è nuova e l'id stato è diverso da aperto,
         * controllo di poter modificare lo stato. Se è possibile
         * modificarlo, modifico; altrimenti faccio uscire il dialog
         * informativo per chiedere conferma. */
        if (this.des_stato != this.des_stato_aperto) {
          // Preparo la request
          const request = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "checkwocommessaattivi",
              token: localStorage.user_token,
              tabella: [this.id_commessa_tmp],
            },
          };

          /* Chiedo al BE se la commessa da modificare è libera.
           * Se mi risponde true faccio la chiamata per modificare,
           * altrimenti stampo un dialog di conferma all'utente.*/
          this.$store.dispatch("api", request).then((res) => {
            if (res.status === 200) {
              if (res.data.response === true) {
                this.dialogSalvataggio = true;
              } else {
                this.items_commesse_aperte = new Array();
                res.data.result.forEach((e) => {
                  this.items_commesse_aperte.push(Object.assign(e));
                });

                this.dialog_impegni = true;
              }
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non è stato possibile caricare i dati."
              );
            }
          });
        } else {
          /* Altrimenti sto cambiando lo stato in aperto
           * e posso fare la procedura normalmente senza
           * controllare eventuali attività.*/
          this.dialogSalvataggio = true;
        }
      }
    },
    clickSalvaEContinua() {
      this.salva_e_continua = true;
      this.clickSalva();
    },
    // In order to delete all fasi
    deleteAllFasi(ev) {
      this.deleteAllFasiLista = ev;
    },
    // In order to Update the deleted Distinta base
    delDistinta(event) {
      this.deletedDistinta.push(event);
    },
    // Check if cicli list is not empty
    updateCicliList(event) {
      event.forEach((elem) => {
        this.deletedCicli.push(elem);
      });
    },
    deleteUselessFields() {
      // Per ogni fase...
      this.CommessaData.commessa_dettaglio.forEach((fase) => {
        // Cancello dalla fase dei parametri che creano poi conflitti con la CRUD.
        if (fase.date_ins !== undefined) delete fase.date_ins;
        if (fase.date_mod !== undefined) delete fase.date_mod;

        // Cancello parametri inutili dal personale.
        if (fase.commessa_dettaglio_personale) {
          fase.commessa_dettaglio_personale.forEach((p) => {
            if (p.date_ins !== undefined) delete p.date_ins;
            if (p.date_mod !== undefined) delete p.date_mod;

            if (fase.id_commessa_dettaglio > -1)
              p.id_temp = fase.id_commessa_dettaglio;
          });
        }

        // Cancello parametri inutili dalle macchine.
        if (fase.commessa_dettaglio_macchina) {
          fase.commessa_dettaglio_macchina.forEach((m) => {
            if (m.date_ins !== undefined) delete m.date_ins;
            if (m.date_mod !== undefined) delete m.date_mod;
            if (fase.id_commessa_dettaglio > -1)
              m.id_temp = fase.id_commessa_dettaglio;
          });
        }

        // Cancello parametri inutili dai fornitori.
        if (fase.commessa_dettaglio_fornitori) {
          fase.commessa_dettaglio_fornitori.forEach((f) => {
            if (f.date_ins !== undefined) delete f.date_ins;
            if (f.date_mod !== undefined) delete f.date_mod;
            if (fase.id_commessa_dettaglio > -1)
              f.id_temp = fase.id_commessa_dettaglio;
          });
        }
      });

      // Controllo che le righe siano ok.
      this.CommessaData.commessa_dettaglio
        .filter((fase) => fase.validita == 1)
        .forEach((fase, idx) => {
          fase.riga = idx + 1;
        });
    },
    delMacchina(event) {
      if (event.length > 0) {
        this.deletedMacchina = event;
      }
    },
    delPersonale(event) {
      if (event.length > 0) {
        this.deletedPersonale = event;
      }
    },
    delFornitura(event) {
      if (event.length > 0) {
        this.deletedFornitura = event;
      }
    },
    goToArticolo() {
      if (this.cod_articolo === "") {
        return;
      }
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo,
          id_famiglia:
            this.id_famiglia.id_tabella == undefined
              ? ""
              : this.id_famiglia.id_tabella,
          id_tipo:
            this.id_tipo.id_tabella == undefined ? "" : this.id_tipo.id_tabella,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 500) {
          this.overlay = false;
        }
        this.completeData = res.data;
        this.overlay = false;
        if (this.completeData.lista.length > 1) {
          this.snackbar = true;
          this.snackbar_background = "success";
          this.snackbar_icon = "mdi-check";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Più articoli corrispondono a questo codice";
          this.snackbar_text_color = "white";
        }
        if (this.completeData.lista.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Nessun articolo trovato con questo codice.";
          this.snackbar_text_color = "white";
        }
        if (this.completeData.lista.length === 1) {
          this.cod_articolo = this.completeData.lista[0].cod_articolo;
          let Getnewcommesa = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "getnewcommessa",
              token: localStorage.getItem("user_token"),
              id_profilo: "3",
              id_articolo: this.completeData.lista[0].id_articolo,
            },
          };
          this.$store.dispatch("api", Getnewcommesa).then((res) => {
            this.overlay = false;
            this.CommessaData = res.data;
            if (!this.CommessaData.commessa_dettaglio) {
              this.CommessaData.commessa_dettaglio = [];
            }
            this.key_commessa_drawer = this.key_commessa_drawer == 0 ? 1 : 0;

            this.cod_articolo = this.CommessaData.commessa[0].cod_articolo;
            this.cod_commessa = this.CommessaData.commessa[0].cod_commessa;
            this.id_um = this.CommessaData.commessa[0].id_um;
            this.des_commessa = this.CommessaData.commessa[0].des_commessa;
            this.id_magazzino = this.CommessaData.commessa[0].id_magazzino;
            this.colore_sfondo = this.CommessaData.commessa[0].colore_sfondo;
            this.colore_testo = this.CommessaData.commessa[0].colore_testo;
            this.data_commessa = this.CommessaData.commessa[0].data_commessa;
            if (this.id_stato == "") {
              this.id_stato = this.CommessaData.commessa[0].id_stato;
            }
            this.stato_list.map((it) => {
              if (it.id_tabella === this.CommessaData.commessa[0].id_stato) {
                this.des_stato = it.des;
              }
            });
            this.des_articolo = this.CommessaData.commessa[0].des_articolo;
            this.data_consegna = this.CommessaData.commessa[0].data_consegna;
            this.id_famiglia = this.CommessaData.commessa[0].id_famiglia;
            this.id_tipo_fornitura =
              this.CommessaData.commessa[0].id_tipo_fornitura;
            this.id_tipo = this.CommessaData.commessa[0].id_tipo;
            this.indice_disegno = this.CommessaData.commessa[0].indice_disegno;
            this.id_articolo = this.CommessaData.commessa[0].id_articolo;
            this.id_packaging_sel =
              this.CommessaData.commessa[0].id_articolo_packaging;
            this.cod_packaging_sel =
              this.CommessaData.commessa[0].cod_articolo_packaging;
          });
          this.cod_articolo_dialog = false;
        }
      });
      this.overlay = false;
      this.dialogListaArticoli = false;
    },
    clickVisualizzaDisegno() {
      this.visualizza_disegno_visible = true;
      this.work_order_sel.id_articolo = this.id_articolo;
    },
    updateArticle(val) {
      val[0].children.map((va) => (va.children = []));
      this.CommessaData.commessa_distinta = val[0].children;
    },
    getMagazzini() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_magazzini = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    handleSelezionataDistinta(arg) {
      // Azzero la validità degli elementi precedenti
      this.CommessaData.commessa_distinta.forEach((e) => {
        e.validita = 0;
        e.children = new Array();
        this.deletedDistinta.push(Object.assign({}, e));
      });

      // Inserisco gli elementi nuovi
      this.CommessaData.commessa_distinta = new Array();

      arg.forEach((elem) => {
        elem.id_commessa_distinta_base = -1;
        this.CommessaData.commessa_distinta.push(Object.assign({}, elem));
      });

      this.$refs.commessa_drawer.key_distinta =
        this.$refs.commessa_drawer.key_distinta === 0 ? 1 : 0;
    },
    handleSelezionePackaging(arg) {
      this.id_packaging_sel = arg.id_articolo_packaging;
      this.cod_packaging_sel = arg.cod_articolo_packaging;
      this.packaging_visible = false;
    },
    // IN order to go back to commessa main page
    goBack() {
      if (this.componente_interno == false) {
        this.$router.push({
          name: "commessa",
          params: { foo: 1 },
        });
      } else {
        this.$emit("click_chiudi_dettaglio");
      }
    },
    // In order to Json to create new commessa
    onDetail(item) {
      this.id_articolo = item.id_articolo;
      this.cod_articolo = item.cod_articolo;
      this.cod_articolo_dialog = false;
      this.dialogListaArticoli = false;
      let Getnewcommesa = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getnewcommessa",
          token: localStorage.getItem("user_token"),
          id_profilo: "3",
          id_articolo: item.id_articolo,
        },
      };
      this.$store.dispatch("api", Getnewcommesa).then((res) => {
        this.CommessaData = res.data;
        this.overlay = false;
        if (!this.CommessaData.commessa_dettaglio) {
          this.CommessaData.commessa_dettaglio = [];
        }
        this.key_commessa_drawer = this.key_commessa_drawer == 0 ? 1 : 0;

        this.data_commessa = this.CommessaData.commessa[0].data_commessa;
        this.des_articolo = this.CommessaData.commessa[0].des_articolo;
        if (this.id_stato == "") {
          this.id_stato = this.CommessaData.commessa[0].id_stato;
        }
        this.stato_list.map((it) => {
          if (it.id_tabella === this.CommessaData.commessa[0].id_stato) {
            this.des_stato = it.des;
          }
        });
        this.id_famiglia = this.CommessaData.commessa[0].famiglia_articolo;
        this.id_magazzino = this.CommessaData.commessa[0].id_magazzino;
        this.id_tipo_fornitura =
          this.CommessaData.commessa[0].fornitura_articolo;
        this.id_tipo = this.CommessaData.commessa[0].tipo_articolo;
        this.indice_disegno = this.CommessaData.commessa[0].indice_disegno;
        this.id_articolo = this.CommessaData.commessa[0].id_articolo;
        this.id_packaging_sel =
          this.CommessaData.commessa[0].id_articolo_packaging;
        this.cod_packaging_sel =
          this.CommessaData.commessa[0].cod_articolo_packaging;
      });
    },
    prelieviCommessa() {
      this.prelievi_visible = true;
    },
    handleAggiornatoCiclo() {
      this.salva_e_continua = true;
      this.SalvaCommessa();
    },
    // IN order to search in search filed to get json to create new commessa
    searchResult() {
      if (this.cod_articolo === "") {
        return;
      }
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo,
          id_famiglia:
            this.id_famiglia.id_tabella == undefined
              ? ""
              : this.id_famiglia.id_tabella,
          id_tipo:
            this.id_tipo.id_tabella == undefined ? "" : this.id_tipo.id_tabella,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 500) {
            this.snackbar = true;
            this.snackbar_background = "error";
            this.snackbar_icon = "mdi-close";
            this.snackbar_icon_color = "white";
            this.snackbar_text = "Nessun articolo trovato con questo codice.";
            this.snackbar_text_color = "white";
            this.overlay = false;
          }
          this.completeData = res.data;
          if (this.completeData.lista.length > 1) {
            this.tableData = this.completeData.lista;
            this.dialogListaArticoli = true;
          }
          if (this.completeData.lista.length === 0) {
            this.snackbar = true;
            this.snackbar_background = "error";
            this.snackbar_icon = "mdi-close";
            this.snackbar_icon_color = "white";
            this.snackbar_text = "Nessun articolo trovato per questo codice";
            this.snackbar_text_color = "white";
          }
          if (this.completeData.lista.length === 1) {
            this.snackbar = true;
            this.snackbar_background = "success";
            this.snackbar_icon = "mdi-check";
            this.snackbar_icon_color = "white";
            this.snackbar_text = "È presente un articolo con questo codice.";
            this.snackbar_text_color = "white";
          }
        })
        .catch((err) => {
          if (err) {
            this.snackbar = true;
            this.snackbar_background = "error";
            this.snackbar_icon = "mdi-close";
            this.snackbar_icon_color = "white";
            this.snackbar_text = "Errore.";
            this.snackbar_text_color = "white";
            this.overlay = false;
          }
        });
      this.dialogListaArticoli = false;
    },
    retrieveImageFromClipboardAsBase64(pasteEvent, callback, imageFormat) {
      if (pasteEvent.clipboardData == false) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      var items = pasteEvent.clipboardData.items;
      if (items == undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      for (var i = 0; i < items.length; i++) {
        // Skip content if not image
        if (items[i].type.indexOf("image") == -1) continue;
        // Retrieve image on clipboard as blob
        var blob = items[i].getAsFile();
        // Create an abstract canvas and get context
        var mycanvas = document.createElement("canvas");
        var ctx = mycanvas.getContext("2d");
        // Create an image
        var img = new Image();
        // Once the image loads, render the img on the canvas
        img.onload = function () {
          // Update dimensions of the canvas with the dimensions of the image
          mycanvas.width = this.width;
          mycanvas.height = this.height;
          // Draw the image
          ctx.drawImage(img, 0, 0);
          // Execute callback with the base64 URI of the image
          if (typeof callback == "function") {
            callback(mycanvas.toDataURL(imageFormat || "image/png"));
          }
        };
        // Crossbrowser support for URL
        var URLObj = window.URL || window.webkitURL;
        // Creates a DOMString containing a URL representing the object given in the parameter
        // namely the original Blob
        img.src = URLObj.createObjectURL(blob);
      }
    },
    onPaste(e) {
      if (e.clipboardData != false) {
        var items = e.clipboardData.items;
        if (items != undefined) {
          for (var i = 0; i < items.length; i++) {
            // Skip content if not image
            if (items[i].type.indexOf("image") == -1) continue;
          }
        }
      }
      this.retrieveImageFromClipboardAsBase64(e, function (imageDataBase64) {
        this.articoloDetail.immagine_preview = imageDataBase64;
      });
    },
    openImagePicker() {
      this.$refs.allegato.click();
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var imagetoBase64 = files[0];
      var dataBase64;
      var reader = new FileReader();
      reader.readAsDataURL(imagetoBase64);
      reader.onload = function () {
        dataBase64 = reader.result;
        this.immagine_preview = dataBase64;
        localStorage.setItem("ArticoloImage", this.immagine_preview);
      };
    },
    setImmagine() {
      this.immagine_preview = localStorage.getItem("ArticoloImage");
      this.dialogAggiungiAllegati = false;
    },
    // In order to save a new commessa or Update an existing one.
    async SalvaCommessa() {
      var nextid = 1;
      for (const c of this.CommessaData.commessa_dettaglio) {
        c.id_temp = nextid;
        if (
          c.commessa_dettaglio_fornitori != null &&
          Array.isArray(c.commessa_dettaglio_fornitori)
        ) {
          for (var df of c.commessa_dettaglio_fornitori) {
            df.id_temp = c.id_temp;
          }
        }
        if (
          c.commessa_dettaglio_macchina != null &&
          Array.isArray(c.commessa_dettaglio_macchina)
        ) {
          for (var dm of c.commessa_dettaglio_macchina) {
            dm.id_temp = c.id_temp;
          }
        }
        if (
          c.commessa_dettaglio_personale != null &&
          Array.isArray(c.commessa_dettaglio_personale)
        ) {
          for (var dp of c.commessa_dettaglio_personale) {
            dp.id_temp = c.id_temp;
          }
        }
        if (
          c.t_moduli_relazioni != null &&
          Array.isArray(c.t_moduli_relazioni)
        ) {
          for (var dr of c.t_moduli_relazioni) {
            dr.id_temp = c.id_temp;
          }
        }
        if (c.operazioni != null && Array.isArray(c.operazioni)) {
          for (var dop of c.operazioni) {
            dop.id_temp = c.id_temp;
          }
        }
        nextid++;
      }

      this.dialogSalvataggio = false;

      if (this.quantita == 0) {
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_icon = "mdi-alert";
        this.snackbar_icon_color = "white";
        this.snackbar_text = "La quantità deve essere maggiore di 0";
        this.snackbar_text_color = "white";
        return;
      }

      if (
        this.tipo_avanzamento == null ||
        this.tipo_avanzamento == "" ||
        this.tipo_avanzamento == "NaN" ||
        isNaN(this.tipo_avanzamento)
      ) {
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_icon = "mdi-alert";
        this.snackbar_icon_color = "white";
        this.snackbar_text = "Selezionare il tipo di avanzamento.";
        this.snackbar_text_color = "white";
        return;
      }

      if (this.des_stato == null) {
        this.$refs.SnackbarQV.print("orange", "Valorizzare lo stato.");
        return;
      }

      if (
        this.CommessaData.commessa[0].tipo_avanzamento == 2 &&
        this.chk_contenitori_magazzino_on_save == 1
      ) {
        let chk_magazzino = await this.chkMagazzinoContenitore();
        if (chk_magazzino == 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Il contenitore non ha un magazzino predefinito."
          );
          return;
        }
      }

      this.CommessaData.commessa_dettaglio = JSON.parse(
        JSON.stringify(this.$refs.commessa_drawer.$refs.ciclo.cicloLista)
      );

      // Cancello i parametri inutili che scompaginano l'esito della CRUD.
      this.deleteUselessFields();

      if (this.CommessaData.commessa[0].id_commessa === -1) {
        if (this.deletedCicli.length > 0) {
          this.deletedCicli.map((it) => {
            this.CommessaData.commessa_dettaglio.push(it);
          });
        }
        this.CommessaData.commessa[0].flag_picking = this.flag_picking;
        this.CommessaData.commessa[0].tipo_avanzamento = this.tipo_avanzamento;
        this.CommessaData.commessa[0].tipo_commessa = this.tipo_commessa;
        this.CommessaData.commessa[0].id_magazzino = this.id_magazzino;
        this.CommessaData.commessa[0].data_commessa = this.data_commessa;
        this.CommessaData.commessa[0].data_consegna = this.data_consegna;
        this.CommessaData.commessa[0].cod_commessa = this.cod_commessa;
        this.CommessaData.commessa[0].quantita = this.quantita;
        this.CommessaData.commessa[0].des_commessa = this.des_commessa;
        this.CommessaData.commessa[0].colore_sfondo = this.colore_sfondo;
        this.CommessaData.commessa[0].colore_testo = this.colore_testo;
        this.CommessaData.commessa[0].des_articolo = this.des_articolo;
        this.CommessaData.commessa[0].barcode = null;
        this.CommessaData.commessa[0].riferimento = this.riferimento;
        this.CommessaData.commessa[0].dum = this.dum;
        this.CommessaData.commessa[0].indice_disegno = this.indice_disegno;
        this.CommessaData.commessa[0].cod_lotto = this.cod_lotto;
        this.CommessaData.commessa[0].id_stato = this.des_stato;
        this.CommessaData.commessa[0].data_spedizione = this.data_spedizione;
        this.CommessaData.commessa[0].id_articolo_packaging =
          this.id_packaging_sel;
        this.stato_list.map((de) => {
          if (de.des === this.des_stato) {
            this.CommessaData.commessa[0].des_stato = de.des;
            this.CommessaData.commessa[0].id_stato = de.id_tabella;
          }
        });
        this.CommessaData.commessa[0].cod_articolo = this.cod_articolo;
        this.tipoList.map((ti) => {
          if (this.id_tipo === ti.des) {
            this.CommessaData.commessa[0].id_tipo = ti.id_tabella;
          }
        });
        this.famiglia_list.map((fi) => {
          if (fi.des === this.famiglia_articolo) {
            this.CommessaData.commessa[0].id_famiglia = fi.id_tabella;
          }
        });
        this.fornitura_list.map((forni) => {
          if (forni.des === this.fornitura_articolo) {
            this.CommessaData.commessa[0].id_tipo_fornitura = forni.id_tabella;
          }
        });
        this.CommessaData.commessa_distinta.map((it) => (it.children = []));

        // Se ci sono annotazioni modificate, le registro.
        if (this.$refs.commessa_drawer.$refs.annotazioni) {
          this.CommessaData.commessa[0].note =
            this.$refs.commessa_drawer.$refs.annotazioni.annotazioni;
        }

        this.CommessaData.commessa_dettaglio.forEach((d) => {
          if (!d.operazioni) {
            d.operazioni = new Array();
          }
        });

        // Correggo il formato delle ore pianificate nei detaìtagli.
        this.CommessaData.commessa_dettaglio.forEach((d) => {
          if (
            d.ora_inizio_pianificata != null &&
            d.ora_inizio_pianificata != ""
          ) {
            d.ora_inizio_pianificata = d.ora_inizio_pianificata.replace(
              "T",
              " "
            );
          }
        });

        // Elimino le fasi nuove non valide.
        this.CommessaData.commessa_dettaglio =
          this.CommessaData.commessa_dettaglio.filter(
            (elem) => elem.id_commessa_dettaglio > 0 || elem.validita == 1
          );

        // Elimino le operazioni non valide.
        this.CommessaData.commessa_dettaglio.forEach((elem) => {
          if (elem.operazioni) {
            elem.operazioni = elem.operazioni.filter(
              (o) =>
                o.id_commessa_operazione > 0 ||
                o.seleziona_suggerimento == 1 ||
                (o.seleziona_suggerimento === undefined && o.validita == 1) ||
                (o.id_commessa_operazione > 0 && o.validita == 0)
            );
          }
        });

        // Fra le operazioni da salvare, invalido quelle disattivate.
        this.CommessaData.commessa_dettaglio.forEach((elem) => {
          elem.operazioni.forEach((o) => {
            if (o.seleziona_suggerimento == 0) {
              o.validita = 0;
            }
          });
        });

        /* Se ho i tipi di pianificazione, ora che sono in creazione di una nuova
         * commessa li uso per segnare che la pianificazione è per forza manuale. */
        if (
          this.items_tipi_pianificazione &&
          this.items_tipi_pianificazione.length > 0
        ) {
          this.CommessaData.commessa_dettaglio.forEach((d) => {
            d.id_tipo_pianificazione = this.items_tipi_pianificazione.filter(
              (p) => p.val_int == 1
            )[0]?.id_tabella;
          });
        }

        let setcommessa = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setcommessa",
            token: localStorage.getItem("user_token"),
            id_commessa: "-1",
            id_articolo: this.id_articolo,
            id_profilo: localStorage.id_profilo,
            tabella: [this.CommessaData],
          },
        };

        this.overlay = true;
        this.$store
          .dispatch("api", setcommessa)
          .then(async (res) => {
            this.overlay = false;
            if (res.status === 200) {
              this.deletedCicli = new Array();
              if (this.salva_e_continua == true) {
                this.salva_e_continua = false;
                this.$router.push(
                  `/home/production/commesa/${res.data.result}`
                );
                this.setDatiGenerali();
                this.getCommessaFull();
              } else {
                this.goBack();
              }

              this.snackbar = true;
              this.snackbar_background = "success";
              this.snackbar_icon = "mdi-check";
              this.snackbar_icon_color = "white";
              this.snackbar_text = "Modifica effettuata con successo!";
              this.snackbar_text_color = "white";
            } else {
              this.snackbar = true;
              this.snackbar_background = "error";
              this.snackbar_icon = "mdi-close";
              this.snackbar_icon_color = "white";
              this.snackbar_text = `Non è stato possibile salvare i dati: codice errore ${res.status}`;
              this.snackbar_text_color = "white";
            }
          })
          .catch((e) => {
            console.error(e);
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile salvare i dati."
            );
          });
      }

      if (this.CommessaData.commessa[0].id_commessa > -1) {
        if (this.deletedCicli.length > 0) {
          this.deletedCicli.map((it) => {
            this.CommessaData.commessa_dettaglio.push(it);
          });
        }
        if (this.deleteAllFasiLista.length > 0) {
          this.deleteAllFasiLista.map((it) => {
            it.validita = 0;
            this.CommessaData.commessa_dettaglio.push(it);
          });
        }
        this.CommessaData.commessa[0].flag_picking = this.flag_picking;
        this.CommessaData.commessa[0].tipo_avanzamento = this.tipo_avanzamento;
        this.CommessaData.commessa[0].tipo_commessa = this.tipo_commessa;
        this.CommessaData.commessa[0].id_magazzino = this.id_magazzino;
        this.CommessaData.commessa[0].cod_commessa = this.cod_commessa;
        this.CommessaData.commessa[0].des_commessa = this.des_commessa;
        this.CommessaData.commessa[0].colore_sfondo = this.colore_sfondo;
        this.CommessaData.commessa[0].colore_testo = this.colore_testo;
        this.CommessaData.commessa[0].data_commessa = this.data_commessa;
        this.CommessaData.commessa[0].data_consegna = this.data_consegna;
        this.CommessaData.commessa[0].data_spedizione = this.data_spedizione;
        this.CommessaData.commessa[0].quantita = this.quantita;
        this.CommessaData.commessa[0].riferimento = this.riferimento;
        this.CommessaData.commessa[0].id_articolo_packaging =
          this.id_packaging_sel;

        this.stato_list.map((it) => {
          if (this.des_stato === it.des) {
            this.CommessaData.commessa[0].id_stato = it.id_tabella;
            this.CommessaData.commessa[0].des_stato = it.des;
          }
        });
        if (this.deletedPersonale.length > 0) {
          this.CommessaData.commessa_dettaglio.map((it) => {
            if (
              it.id_commessa_dettaglio ===
              this.deletedPersonale[0].id_commessa_dettaglio
            ) {
              this.deletedPersonale.map((pe) => {
                it.commessa_dettaglio_personale.push(pe);
              });
            }
          });
        }
        if (this.deletedMacchina.length > 0) {
          this.CommessaData.commessa_dettaglio.map((it) => {
            if (
              it.id_commessa_dettaglio ===
              this.deletedMacchina[0].id_commessa_dettaglio
            ) {
              this.deletedMacchina.map((pe) => {
                it.commessa_dettaglio_macchina.push(pe);
              });
            }
          });
        }
        if (this.deletedFornitura.length > 0) {
          this.CommessaData.commessa_dettaglio.map((it) => {
            if (
              it.id_commessa_dettaglio ===
              this.deletedFornitura[0].id_commessa_dettaglio
            ) {
              this.deletedFornitura.map((pe) => {
                it.commessa_dettaglio_fornitori.push(pe);
              });
            }
          });
        }
        if (this.deletedDistinta.length > 0) {
          this.deletedDistinta.map((it) => {
            this.CommessaData.commessa_distinta.push(it);
          });
        }

        // Se ci sono annotazioni modificate, le registro.
        if (this.$refs.commessa_drawer.$refs.annotazioni) {
          this.CommessaData.commessa[0].note =
            this.$refs.commessa_drawer.$refs.annotazioni.annotazioni;
        }

        this.CommessaData.commessa_dettaglio.forEach((d) => {
          if (!d.operazioni) {
            d.operazioni = new Array();
          }
        });

        // Correggo il formato delle ore pianificate nei detaìtagli.
        this.CommessaData.commessa_dettaglio.forEach((d) => {
          if (
            d.ora_inizio_pianificata != null &&
            d.ora_inizio_pianificata != ""
          ) {
            d.ora_inizio_pianificata = d.ora_inizio_pianificata.replace(
              "T",
              " "
            );
          }
        });

        // Elimino le fasi nuove non valide.
        this.CommessaData.commessa_dettaglio =
          this.CommessaData.commessa_dettaglio.filter(
            (elem) => elem.id_commessa_dettaglio > 0 || elem.validita == 1
          );

        // Elimino le operazioni non valide.
        this.CommessaData.commessa_dettaglio.forEach((elem) => {
          if (elem.operazioni) {
            elem.operazioni = elem.operazioni.filter(
              (o) =>
                o.id_commessa_operazione > 0 ||
                o.seleziona_suggerimento == 1 ||
                (o.seleziona_suggerimento === undefined && o.validita == 1) ||
                (o.id_commessa_operazione > 0 && o.validita == 0)
            );
          }
        });

        // Fra le operazioni da salvare, invalido quelle disattivate.
        this.CommessaData.commessa_dettaglio.forEach((elem) => {
          elem.operazioni.forEach((o) => {
            if (o.seleziona_suggerimento == 0) {
              o.validita = 0;
            }
          });
        });

        /* Se ho i tipi di pianificazione, ora che sono in modifica di una commessa
         * esistente indico come manuale la pianificazione delle fasi che hanno il tipo
         * pianificazione marcato con id nullo. */
        if (
          this.items_tipi_pianificazione &&
          this.items_tipi_pianificazione.length > 0
        ) {
          this.CommessaData.commessa_dettaglio.forEach((d) => {
            if (d.id_tipo_pianificazione == null)
              d.id_tipo_pianificazione = this.items_tipi_pianificazione.filter(
                (p) => p.val_int == 1
              )[0]?.id_tabella;
          });
        }

        // Invio la request.
        let setcommessa = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setcommessa",
            token: localStorage.getItem("user_token"),
            id_commessa: this.id_commessa_tmp,
            id_articolo: this.id_articolo,
            id_profilo: localStorage.id_profilo,
            tabella: [this.CommessaData],
          },
        };

        this.overlay = true;
        this.$store
          .dispatch("api", setcommessa)
          .then(async (res) => {
            this.overlay = false;
            if (res.status === 200) {
              this.deletedCicli = new Array();
              if (this.salva_e_continua == true) {
                this.salva_e_continua = false;
                this.getCommessaFull();
              } else {
                this.$emit("salvataggio_effettuato");
                this.goBack();
              }

              this.snackbar = true;
              this.snackbar_background = "success";
              this.snackbar_icon = "mdi-check";
              this.snackbar_icon_color = "white";
              this.snackbar_text = "Modifica effettuata con successo!";
              this.snackbar_text_color = "white";
            } else {
              this.snackbar = true;
              this.snackbar_background = "error";
              this.snackbar_icon = "mdi-close";
              this.snackbar_icon_color = "white";
              this.snackbar_text = `Non è stato possibile salvare i dati: codice errore ${res.status}`;
              this.snackbar_text_color = "white";
            }
          })
          .catch((e) => {
            console.error(e);
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile salvare i dati."
            );
          });
      }
    },
    printCommessa() {
      let request = {
        controller: "Report",
        method: "POST",
        richiesta: {
          action: "getreportpdf",
          token: localStorage.getItem("user_token"),
          cod_report: "COMMESSA",
          parametri: [
            {
              parametro: "@id",
              valore: this.CommessaData.commessa[0].id_commessa,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (
            "tipo_messaggio" in res.data &&
            "query_messaggio" in res.data &&
            res.data.tipo_messaggio == 1
          ) {
            this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
          }
          const byteCharacters = atob(res.data.result);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/pdf",
          });
          const blobUrl = URL.createObjectURL(blob);
          this.selected_pdf = blobUrl;
          this.pdfdialog = true;
        })
        .catch((err) => {
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
    },
    setDatiGenerali() {
      this.id_commessa_tmp = this.$route.params.id;
      this.CommessaData = this.data;
      this.key_commessa_drawer = this.key_commessa_drawer == 0 ? 1 : 0;

      this.cod_commessa = this.CommessaData.commessa.cod_commessa;
      this.des_commessa = this.CommessaData.commessa.des_commessa;
      this.colore_sfondo = this.CommessaData.commessa.colore_sfondo;
      this.colore_testo = this.CommessaData.commessa.colore_testo;
      this.indice_disegno = this.CommessaData.commessa.indice_disegno;
      this.id_articolo = this.CommessaData.commessa.id_articolo;
    },
  },
  computed: {
    formatdatacommessa() {
      return this.data_commessa
        ? moment(this.data_commessa).format("DD/MM/YYYY")
        : "";
    },
    formatdataconsegna() {
      return this.data_consegna
        ? moment(this.data_consegna).format("DD/MM/YYYY")
        : "";
    },
    formatdatadum() {
      return this.dum ? moment(this.dum).format("DD/MM/YYYY") : "";
    },
    format_data_spedizione() {
      return this.data_spedizione
        ? moment(this.data_spedizione).format("DD/MM/YYYY")
        : "";
    },
  },
  mounted() {
    document
      .getElementById("listener_commessa_dashboard")
      .addEventListener("aggiornato_ciclo", this.handleAggiornatoCiclo);
    this.getMagazzini();
    this.aggiornaTipoCommessa();

    /* Registro quali chiamate deve effettuare il componente
     * packaging, se quelle per il report o la label. */
    this.getModuliDrawer();

    if (this.id_commessa != null) {
      this.$route.params.id = this.id_commessa;
    }
    // Aggiungo il listener per il campo di input
    this.overlay = false;
    let that = this;
    setTimeout(() => {
      document
        .getElementById("listener_quantita")
        ?.addEventListener("nuovo_numero", function (elem) {
          that.quantita = elem.detail.numero;
        });
    }, 10);
    if (this.$route.params.id == -1) {
      this.id_commessa_tmp = -1;
      this.cod_articolo_dialog = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getimpostazionicommesse",
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.data.statusCode == 200) {
          var tempImpo = res.data.result.impostazioni[0].note;
          this.tipo_avanzamento = parseInt(tempImpo.split(",")[0]);
          this.id_stato = parseInt(tempImpo.split(",")[3]);
          if (tempImpo.split(",")[4] == "Si") {
            this.flag_picking = true;
          } else {
            this.flag_picking = false;
          }
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            "Impossibile Caricare Impostazioni"
          );
        }
        this.impostazioniDialog = false;
      });
    }

    this.setDatiGenerali();

    let listaArticoli = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "getheader",
        token: localStorage.getItem("user_token"),
        nome_modulo: "lista_articoli",
      },
    };
    let dataarray = [];
    this.$store.dispatch("api", listaArticoli).then((res) => {
      dataarray = res.data;
      dataarray.map((el) => {
        this.headers.push({
          text: el.text,
          value: el.value,
        });
      });
      this.headers.splice(0, 0, {
        text: "dettaglio",
        value: "actions",
      });
    });
    // In order to get Saved Commessa Detail
    if (this.$route.params.id >= 1) {
      this.getCommessaFull();
    }
    // IN order to get List data for select fields
    let request2 = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "gettabelle",
        token: localStorage.getItem("user_token"),
        db_name: "quickproduction",
        tipo: "'UNITA_MISURA','FAMIGLIA','TIPOARTICOLO','FORNITURA_STANDARD','COMMESSA_STATO','TIPO_AVANZAMENTO_COMMESSA','COMMESSA_TIPO', 'QP_TIPO_PIANIFICAZIONE'",
        filter: "validita = 1",
      },
    };

    this.$store.dispatch("api", request2).then((res) => {
      this.famiglia_list =
        res.data.Famiglia != undefined
          ? res.data.Famiglia
          : res.data.FAMIGLIA != undefined
          ? res.data.FAMIGLIA
          : [];
      this.fornitura_list = res.data.FORNITURA_STANDARD
        ? res.data.FORNITURA_STANDARD
        : [];
      this.tipoList = res.data.TIPOARTICOLO ? res.data.TIPOARTICOLO : [];
      this.items_unita_misura = res.data.UNITA_MISURA
        ? res.data.UNITA_MISURA
        : [];
      this.tipi_avanzamento = res.data.TIPO_AVANZAMENTO_COMMESSA
        ? res.data.TIPO_AVANZAMENTO_COMMESSA
        : [];
      this.tipi_commessa = res.data.COMMESSA_TIPO ? res.data.COMMESSA_TIPO : [];
      this.items_tipi_pianificazione = res.data.QP_TIPO_PIANIFICAZIONE
        ? res.data.QP_TIPO_PIANIFICAZIONE
        : [];

      this.stato_list = res.data.COMMESSA_STATO;
      res.data.COMMESSA_STATO.forEach((e) => {
        if (e.val_int === 1) {
          this.des_stato_aperto = e.des;
        }
      });
      this.stato_list.map((it) => {
        if (it.id_tabella === this.id_stato) {
          this.des_stato = it.des;
        }
      });
    });
    // IN order to get Macchina Lista
    let manu_detail = {
      controller: "Manutenzione",
      method: "POST",
      richiesta: {
        action: "getlistamacchine",
        token: localStorage.getItem("user_token"),
        db_name: "quickproduction",
      },
    };
    this.$store.dispatch("api", manu_detail).then((res) => {
      this.itemList = res.data.macchine;
      this.itemList.map((el) => {
        this.des_stato_list.push(el.des_stato);
      });
    });
    this.des_stato_list.filter((item, index) => {
      if (this.des_stato_list.indexOf(item) == index && item !== null)
        return item != null;
    });
  },
  beforeDestroy() {
    if (document.getElementById("listener_commessa_dashboard")) {
      document
        .getElementById("listener_commessa_dashboard")
        .removeEventListener("aggiornato_ciclo", this.handleAggiornatoCiclo);
    }
  },
};
</script>
<style lang="scss">
.inputClass input {
  color: grey !important;
  box-shadow: none !important;
  border-bottom: none !important;
  outline: none !important;
}
.inputClass.v-input .v-input__slot {
  border-bottom: none !important;
  position: relative !important;
}
.inputClass label {
  color: black !important;
  font-weight: bold !important;
}
.dataClass label {
  color: black !important;
  font-weight: bold !important;
}
.artDialog {
  overflow-x: hidden;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
  max-height: 100% !important;
}
.pdfdialog {
  overflow: hidden;
}
</style>
